<template>
    <section class="scored-activities">
        <div class="score-header">
            <h3>Scored activity</h3>

            <div v-if="showScoreValue" class="lead-score" data-qa="over-all-score">
                <span class="score semibold">{{ scoreValue }}</span>

                <span v-for="({ value }) in overallScore" :key="value">
                    <ds-icon class="fire-icon" name="fire-fill" />
                </span>

                <span v-for="({ value }) in (5 - overallScore)" :key="value">
                    <ds-icon class="fire-icon" name="fire" />
                </span>
            </div>
        </div>

        <div v-if="contactHasScoreActivity" class="scoredactivity-details scored-activity">
            <ds-list-item
                v-for="(score, index) in scoredActivities"
                :key="index"
                class="score-details"
                data-qa="scored-list"
            >
                <template #leading>
                    <ds-icon name="fire" />
                </template>

                <template #description>
                    <div class="score-title">
                        <!-- As we are getting HTML content from back end which can not be stored in any way other than HTML, Hence using v-html -->
                        <!-- eslint-disable-next-line vue/no-v-html -->
                        <span v-html="score.name" />
                    </div>

                    <div class="created-date">
                        {{ score.formattedDate }}
                    </div>
                </template>

                <template #trailing>
                    <p class="flame">
                        <span class="flame-count semibold">+{{ score.points }}</span>

                        <span class="flame-text">points</span>
                    </p>
                </template>
            </ds-list-item>
        </div>

        <div v-else>
            <div class="no-data no-scored" data-qa="no-scored">
                There is no scored activity to report.
            </div>
        </div>

        <div class="score-header">
            <h3>Recent activity</h3>
        </div>

        <div v-if="contactHasRecentActivity" class="scoredactivity-details recent-activity">
            <ds-list-item
                v-for="(score, index) in recentActivityList"
                :key="index"
                class="score-details"
                data-qa="recent-list"
                :border-style="index === recentActivityList.length - 1 ? 'none' : 'partial'"
            >
                <template #leading>
                    <ds-icon name="activity" />
                </template>

                <template #description>
                    <div class="score-title">
                        <!-- As we are getting HTML content from back end which can not be stored in any way other than HTML, Hence using v-html -->
                        <!-- eslint-disable-next-line vue/no-v-html -->
                        <span v-html="score.activityDesc" />
                    </div>

                    <div class="created-date">
                        {{ score.formattedActivityDate }}
                    </div>
                </template>
            </ds-list-item>
        </div>

        <div v-else>
            <div class="no-data no-recent" data-qa="no-recent">
                There is no recent activity to report.
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        contact: Object,
        tabName: String,
    },

    data() {
        return {
            loaded: false,
            url: '/app/contact/loadScoreRecentActivity',
            scoreValue: Number,
            scoredActivities: {},
            recentActivities: {},
            recentActivityList: [],
        };
    },

    created() {
        this.loadAllScoredActivities();
    },

    computed: {
        contactHasScoreActivity() {
            return Object.keys(this.scoredActivities)?.length !== 0;
        },

        contactHasRecentActivity() {
            return Object.keys(this.recentActivities)?.length !== 0;
        },

        overallScore() {
            if (this.scoreValue) {
                return Math.round(this.scoreValue);
            }

            return 0;
        },

        showScoreValue() {
            return this.scoreValue > 0;
        },
    },

    methods: {
        async loadAllScoredActivities() {
            try {
                const response = await axios.get(`${this.url}/${this.contact.id}`);

                this.scoreValue = response.data.overallScoreValue;
                this.scoredActivities = response.data.scoreActivity;
                this.recentActivities = response.data.recentActivity;
                this.recentActivityList = this.recentActivities[this.contact.id];
            } catch (error) {
                this.$error({ message: 'Unable to get scored activities for this contact' });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.scored-activities {
    padding-top: $spacing-100;

    .score-header {
        display: flex;
        justify-content: space-between;
        padding: $spacing-200 0;

        .fire-icon {
            --icon-size: 1rem;
            fill: $color-black;
        }

        .score {
            margin-right: 0.2rem;
            margin-bottom: 0.1rem;
        }

        .lead-score {
            display: flex;
            align-items: center;
        }
    }

    @media($medium) {
        .scoredactivity-details {
            margin-left: $spacing-200;

            &.scored-activity {
                margin-bottom: $spacing-200;
            }
        }
    }

    .flame {
        float: right;
        font-size: px-to-rem(13px);

        .flame-count {
            margin-right: 0.3rem;
        }

        .flame-text {
            color: $color-gray-darker;
        }
    }

    .created-date {
        font-size: 0.8rem;
        color: $color-gray-darker;
    }

    .score-title {
        font-size: $font-size-md;
        color: $color-text;
    }

    .no-data {
        font-size: 1.2rem;
        padding-top: $spacing-600;
        padding-bottom: $spacing-600;
        text-align: center;
    }

    .score-details {
        padding: $spacing-100 0 0;
    }
}
</style>
